import axios from 'axios';

/**
 * Setup global Axios interceptors for error handling
 * This must be called early in the app initialization (e.g., in index.tsx)
 */
export const setupAxiosInterceptors = () => {
  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => {
      // Pass through successful responses
      return response;
    },
    (error) => {
      // Check if this is a 401 Unauthorized error
      if (error.response && error.response.status === 401) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('Received 401 Unauthorized - redirecting to login');
        }

        // Clear any stored auth state (optional)
        localStorage.removeItem('auth0.is.authenticated');

        // Redirect to login page
        window.location.href = '/login';

        // Return a rejected promise to stop further error handling
        return Promise.reject({
          ...error,
          handled: true,
          message: 'Session expired. Redirecting to login...'
        });
      }

      // For non-401 errors, pass them through
      return Promise.reject(error);
    }
  );

  if (process.env.NODE_ENV === 'development') {
    console.log('Axios interceptors configured for 401 handling');
  }
};
